import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

// Lazy loading de componentes - usando named exports correctamente
const Home = lazy(() => import('@feature/home').then(m => ({ default: m.Home })));
const ListUsers = lazy(() => import('@feature/users').then(m => ({ default: m.ListUsers })));
const Monitor = lazy(() => import('@feature/monitor').then(m => ({ default: m.Monitor })));
const NotificationList = lazy(() => import('@feature/notificationsList').then(m => ({ default: m.NotificationList })));
const Profile = lazy(() => import('@feature/profile').then(m => ({ default: m.Profile })));

import { ROUTES } from '@shared/constants/routes.constants';

/**
 * Rutas principales de la aplicación
 */
export const mainRoutes: RouteObject[] = [
  {
    path: ROUTES.MAIN.HOME,
    element: <Home />,
  },
  {
    path: ROUTES.MAIN.USERS,
    element: <ListUsers />,
  },
  {
    path: ROUTES.MAIN.MONITOR,
    element: <Monitor />,
  },
  {
    path: ROUTES.MAIN.NOTIFICATIONS,
    element: <NotificationList />,
  },
  {
    path: ROUTES.MAIN.PROFILE,
    element: <Profile />,
  }
];
